<template >
  <div>
    <div v-if="loading" class="over container">
      <div class="row" style="height: 45vh">
        <div class="col-12"></div>
      </div>
      <div class="row">
        <div class="spinner-border text-primary center" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    </div>
    <div v-else>
      <div id="mesure" class="info"></div>
      <div id="wrapper">
        <div id="animationRope">
          <div id="background-rope"></div>
        </div>
        <div id="full-width-one" style="font-size: 18px !important;
    font-family: 'Varela Round';">
          <header role="banner" id="header">
            <a href="#welcomePage" v-smooth-scroll="{ duration: 3000, offset: 0 }" @click="backToTop">
              <div id="logo" class="ml-5">
                <!-- <img
                  src="../../static/img/logoOnly.png"
                  alt="Logo du club Apnea Club Genève en blanc"
                /> -->
                <img src="../../static/img/LogoWhite.png" alt="" />

                <!-- <img src="../../static/img/logoFreeDivingEinDor.png" alt="" /> -->


              </div>
            </a>
            <nav role="navigation" id="navigation">
              <ul id="menu" class="pb-4 rtl">
                <li class="internal">
                  <!-- <a class="pb-2" @click="showContentOnClick('le-club', 'devenir-membre')" id="leClubMenu"
                    href="#leClub" v-smooth-scroll="{
                      duration: 3000,
                      offset: -200,
                      easingFunction: 'easeOutQuad',
                    }">צלילה חופשית</a> -->
                  <a class="pb-2" id="leClubMenu" href="#leClub" v-smooth-scroll="{
                    duration: 3000,
                    offset: -200,
                    easingFunction: 'easeOutQuad',
                  }">צלילה חופשית</a>
                </li>
                <li class="internal">
                  <!-- <a class="pb-2" @click="showContentOnClick('trainings', 'test2')" id="activitesMenu" href="#activites"
                    v-smooth-scroll="{
                      duration: 3000,
                      offset: -250,
                      easingFunction: 'easeOutQuad',
                    }">קורסים ואימונים</a> -->
                  <a class="pb-2" id="activitesMenu" href="#activites" v-smooth-scroll="{
                    duration: 3000,
                    offset: -250,
                    easingFunction: 'easeOutQuad',
                  }">קורסים ואימונים</a>
                </li>
                <!-- <li class="internal">
                  <a
                    id="galerieMenu"
                    class="pb-2"
                    href="#galerie"
                    v-smooth-scroll="{
                      duration: 3000,
                      offset: -250,
                      easingFunction: 'easeOutQuad',
                    }"
                    >גלריה</a
                  >
                </li> -->
                <li class="internal" style="margin-left: 0px;
">
                  <!-- <a @click="showContentOnClick('contactDetails', 'contactDetails')" id="contactMenu" class="pb-2"
                    href="#contact" v-smooth-scroll="{
                      duration: 3000,
                      offset: -250,
                      easingFunction: 'easeOutQuad',
                    }">צור קשר</a> -->
                  <a id="contactMenu" class="pb-2" href="#contact" v-smooth-scroll="{
                    duration: 3000,
                    offset: -250,
                    easingFunction: 'easeOutQuad',
                  }">צור קשר</a>
                </li>
              </ul>
            </nav>
          </header>
          <div class="row rowMesuresData">
            <div class="col-4" id="timer">00:00:00</div>
            <div class="col-4 rtl">
              {{ (windowTop / 1000 + 1).toFixed(1) }} בר
            </div>
            <div class="col-4 h4">{{ (windowTop / 100).toFixed(2) }}</div>
          </div>
          <div class="row rowMesures">
            <div class="col-4">זמן</div>
            <div class="col-4">לחץ</div>
            <div class="col-4">עומק</div>
          </div>
        </div>
        <main>
          <div id="background-image-one">
            <div id="welcomePage">
              <!-- <div id="loading">LOADING...</div> -->
              <div id="fullscreen-bg" :class="{ fixed: isFixed }">
                <video playsinline loop muted autoplay class="fullscreen-bg__video">
                  <source src="../../static/videos/lacCalme.webm" type="video/webm" />
                  <source src="../../static/videos/lacCalme.mp4" type="video/mp4" />
                  <!-- <source src="../../static/videos/lacCalme.ogv" type="video/ogg"> -->
                </video>
                <div id="logoWelcome">
                  <!-- <img src="../../static/img/logoFreeDivingEinDor.png" alt="" /> -->
                  <img src="../../static/img/LogoWhite.png" alt="" />

                </div>
                <a @click="
  isFixed = false;
clearCountDown();
showContentOnClick('le-club', 'devenir-membre');
countSeconds(0, 0, 0);
                " style="
                      color: white;
                      text-decoration: none;
                      font-family: 'Varela Round', sans-serif;
                    " href="#leClub" v-smooth-scroll="{ duration: 2400, offset: -200 }">
                  <div id="diveIn">
                    לצלול
                  </div>

                </a>
                <!-- v-smooth-scroll="{ duration: 1000, offset: -50, container: '#welcomePage', updateHistory: false }" -->
              </div>
            </div>
            <div class="transparent"></div>

            <div id="leClub" class="inline section_home" style="font-size: 18px !important;
    font-family: 'Varela Round';">
              <!-- <h1>Le Club</h1>            -->
              <!-- <div class="droite wow g_v_d" @click="showContent('le-club')"> -->
              <div class="droite wow g_v_d">

                <div class="row fadeInUp">
                  <h2 class="middleLeft">צלילה חופשית</h2>
                </div>
                <div class="sectionTitle">
                  <div class="hideContent row" ref="le-club">
                    <div class="col-6 d-flex justify-content-center pr-2">
                      <img src="../../static/img/anpeaHebrew/GOPR1521.png" alt="" class="imgAll" />
                    </div>
                    <div class="col-6 pl-3" style="direction: rtl">
                      <h3>מה זה?</h3>
                      <p>
                        <strong> צלילה חופשית </strong>
                        היא ספורט אתגרי המתבצע ללא שימוש באמצעי עזר לנשימה
                        והצולל מתבסס רק על האויר הנמצא בריאותיו. ניתן לתרגל
                        צלילה חופשית גם בים וגם בבריכה. לצלילה החופשית ישנם
                        סגנונות שונים ובהתאם , אמצעי העזר איתם היא מתבצעת כמו
                        מסיכה, סנפירים, חליפה, משקולות, גרבי צלילה. מתקיימות
                        תחרויות בכל העולם בסגנונות השונים וזהו ספורט שמאגד תחתיו
                        עשרות אלפי אנשים
                      </p>
                      <h3>למי זה מתאים?</h3>
                      <p>
                        הצלילה מתאימה לאנשים עם בריאות טובה ורמת שחייה בסיסית.
                        <br />
                        על פי AIDA (ארגון הצלילה החופשית המוכר ביותר) , אפשר
                        להתחיל לצלול מגיל 16 עם אישור הורים. אחד הדברים הקסומים
                        בצלילה חופשית, שלא כמו בענפים רבים אחרים, הוא שאפשר
                        להמשיך לצלול ולהנות מהמדיטציה התת ימית גם בגיל מאוחר
                        והיא אינה דורשת כושר גופני גבוה מאוד
                      </p>
                    </div>

                  </div>
                </div>
              </div>

              <!-- <div class="gauche wow g_v_d" @click="showContent('devenir-membre')"> -->
              <div class="gauche wow g_v_d">

                <div class="row fadeInUp">
                  <h2 class="middleRight">למה צלילה חופשית? </h2>
                </div>
                <div class="sectionTitle">
                  <div class="hideContent row" ref="devenir-membre">
                    <div class="col-6 pr-4" style="direction: rtl">
                      <h3>מילה "חופשית"</h3>
                      <p>
                        כל המשמעות של הספורט הימי הזה מתבטאת במילה "חופשית". בלי
                        בלונים, בלי אמצעי עזר, יורדים מתחת למים בנשימה אחת.
                        הצלילה מאפשרת לנטרל את חוק הכבידה, לנוע בחופשיות במרחב
                        תלת מימדי ובעצם לחוות ביקור בתווך הימי שאיננו חיים בו.
                      </p>
                      <h3>שילובים</h3>
                      <p>
                        השילוב בין ריכוז ושחרור, גורם לצולל תחושות של שלווה
                        אינסופית. זהו בעצם ספורט שהאתגר בו הוא ההרפיה צלילה
                        חופשית היא כלי מדהים לחיזוק המסוגלות שלנו. מאוד מהר
                        אנחנו מגיעים להישגים שלעולם לא חשבנו שנוכל להגיע אליהם.
                        צלילה חופשית היא ריקוד יפהפה עם הקוטביות; בצד אחד חשוב
                        להיות חד ומרוכז, אך בו זמנית חייבים לשחרר ולהיות שלווים.
                      </p>
                    </div>
                    <div class="col-6 d-flex justify-content-center pl-1">
                      <img src="../../static/img/anpeaHebrew/GOPR1662.png" alt="" class="imgAll" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="transparent"></div>
            <div id="activites" ref="activites" class="inline section_home" style="font-size: 18px !important;
    font-family: 'Varela Round';">
              <!-- <h1>Le Club</h1>            -->
              <!-- <div class="droite wow g_v_d" @click="showContent('trainings')"> -->
              <div class="droite wow g_v_d">

                <div class="row fadeInUp">
                  <h2 class="middleLeft">אימונים</h2>
                </div>
                <div class="sectionTitle">
                  <!-- <div class="hideContent row" ref="trainings"> -->
                  <div class=" row" ref="trainings">

                    <div class="col-6 d-flex justify-content-center pr-2">
                      <img src="../../static/img/anpeaHebrew/Competiton2.png" alt="" class="imgAll" />
                    </div>
                    <div class="col-6 pl-3" style="direction: rtl">
                      <h3>בריכה</h3>
                      <p>
                        קיבוץ עין דור - ימי שלישי כל שבוע - בחודש יוני בשעה 19:00
                        ומחודש יולי בשעה 20:00

                      </p>
                      <h3>תוכן:</h3>
                      <p>
                      <ul>
                        <li>טכניקת שחיה מתחת למים
                        </li>
                        <li>נשימות</li>
                        <li>התמודדות עם "הצורך לנשום"
                        </li>
                        <li>תרגול</li>
                      </ul>
                      </p>
                      <h3>תנאי קבלה</h3>
                      <p>
                        הצוללנים החדשים המעוניינים להצטרף לחוג צריכים לעבור קורס
                        בן 8 שעות שיתן להם את הכלים להשתתף באימונים.
                        <br>
                        תנאיי קבלה לקורס: גיל מינימאלי 16 שנים ויכולת לשחות 200 מטר ברצף.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="gauche wow g_v_d" @click="showContent('test2')"> -->
              <div class="gauche wow g_v_d">

                <div class="row fadeInUp">
                  <h2 class="middleRight">קורסים </h2>
                </div>
                <div class="sectionTitle">
                  <!-- <div class="hideContent row" ref="test2"> -->
                  <div class=" row" ref="test2">

                    <div class="col-6 pr-4" style="direction: rtl">
                      <h3>AIDA</h3>
                      ישנון 3 רמות של קורסים ברמת קושי עולה המשלבים ים ובבריכה.
                      <br />

                      <div class="courseDetails">

                        <strong>
                          AIDA 1

                        </strong>

                        - קורס הכרות המשלב תיאוריה ואימון בבריכה או ים –
                        זהו קורס מבוא לעולם הצלילה החופשית ואין בו עמידה ביעדים
                        מלבד ההנאה

                        <br />

                      </div>
                      <div class="courseDetails">

                        <strong>
                          AIDA 2 - בריכה

                        </strong>

                        - קורס המשלב תיאוריה ואימון בבריכה -
                        הצולל שמסיים את הקורס צריך להיות מסוגל להחזיק את הנשימה
                        לפרק זמן של לפחות 2 דקות ולשחות 40 מטר מתחת למים עם
                        סנפירים.


                      </div>
                      <div class="courseDetails">

                        <strong>
                          AIDA 2</strong>

                        - קורס המשלב תיאוריה ואימון בבריכה וים -
                        הצולל שמסיים את הקורס צריך להיות מסוגל להחזיק את הנשימה
                        לפרק זמן של לפחות 2 דקות, לשחות 40 מטר מתחת למים עם
                        סנפירים ולצלול לעומק של 12 מטר.


                      </div>
                      <div class="courseDetails">
                        <strong>
                          AIDA 3 - בריכה

                        </strong>

                        - קורס המשלב תיאוריה ואימון בבריכה -
                        הצולל שמסיים את הקורס צריך להיות מסוגל להחזיק את הנשימה
                        לפרק זמן של לפחות 2:45 דקות ולשחות 55 מטר מתחת למים עם
                        סנפירים.


                      </div>
                      <div class="courseDetails"> <strong>
                          AIDA 3

                        </strong>

                        - קורס המשלב תיאוריה ואימון בבריכה - הצולל
                        שמסיים את הקורס צריך להיות מסוגל להחזיק את הנשימה לפרק
                        זמן של לפחות 2:45 דקות, לשחות 55 מטר מתחת למים עם
                        סנפירים ולצלול לעומק של 24 מטר.

                        <!-- <
                        </div>/div> -->


                      </div>
                    </div>

                    <div class="col-6 d-flex justify-content-center pl-1">
                      <img src="../../static/img/anpeaHebrew/GOPR1580.png" alt="" class="imgAll" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="transparent" style="height: 400px"></div>
            <!-- <div id="galerie" class="inline section_home">
              <div class="alignCenter">
                <figure class="image" @click="openImage('image1')">
                  <img
                    ref="image1"
                    src="../../static/img/competiton.jpg"
                    alt="Apnéiste nagant dans une piscine"
                  />
                </figure>
                <figure class="image" @click="openImage('image2')">
                    <img
                      ref="image2"
                      src="../../static/img/anpeaHebrew/Competiton6.png"
                      alt="Photo d'apnéistes autour d'un bateau pneumatique sur le lac Léman"
                    />
                </figure>
                <figure class="image" @click="openImage('image3')">
                    <img
                      ref="image3"
                      src="../../static/img/anpeaHebrew/Competiton7.png"
                      alt="Photo d'un podium lors de la compétition de l'Apnea Club Genève à la piscine des vernets"
                  />
                </figure>
                <figure class="image" @click="openImage('image4')">
                    <img
                      ref="image4"
                      src="../../static/img/anpeaHebrew/IC.png"
                      alt="Photo d'apnéiste lors d'une sortie en fosse"
                  />
                </figure>
                <figure class="image" @click="openImage('image5')">
                    <img
                      ref="image5"
                      src="../../static/img/anpeaHebrew/Satil.png"
                      alt="Apnéiste nagant dans une piscine"
                  />
                </figure>
                <figure class="image" @click="openImage('image6')">
                    <img
                      ref="image6"
                      src="../../static/img/anpeaHebrew/GOPR1630.png"
                      alt="Photo d'apnéistes autour d'un bateau pneumatique sur le lac Léman"
                    />            
                </figure>
                <figure class="image" @click="openImage('image7')">
                    <img
                      ref="image7"
                      src="../../static/img/anpeaHebrew/Competiton7.png"
                      alt="Photo d'un podium lors de la compétition de l'Apnea Club Genève à la piscine des vernets"
                  />
                </figure>
                <figure class="image" @click="openImage('image8')">
                  <img
                    ref="image8"
                    src="../../static/img/anpeaHebrew/Competiton2.png" class="thumb"
                  />
                </figure>
                <div class="clear"></div>
              </div>
            </div>
            <div v-if="showImageSelected" id="showImage">
              <img :src="src" alt="" />
            </div> -->
            <div id="contact" ref="contact" class="inline section_home" style="font-size: 18px !important;
    font-family: 'Varela Round';">
              <!-- <div class="droite wow g_v_d" @click="showContent('contactDetails')"> -->
              <div class="droite wow g_v_d">

                <div class="row fadeInUp sectionTitle">
                  <h2 class="middleLeft">צור קשר</h2>
                </div>
                <div class="sectionTitle">
                  <!-- <div class="hideContent row" ref="contactDetails"> -->
                  <div class=" row" ref="contactDetails">

                    <div class="col-6 d-flex justify-content-center pr-2">
                      <img src="../../static/img/contactPic.png" alt="" class="imgAll" />
                    </div>
                    <div class="col-6 pl-3 rtl">

                      <h3>כתבו לנו</h3>
                      אתם רוצים לגלות את עולם הנפלא של צלילה חופשית?
                      <br>
                      <br>

                      רוצים לעשות קורס או להשתתף באימונים?
                      <br>
                      <br>

                      צרו איתי קשר, רפאל רוטה, מקום שני באליפות ישראל 2018 בצלילה חופשית דינמית ו
                      <a href="https://www.aidainternational.org/InstructorProfile/1275b6f3-ee6e-477a-b683-555ae950119d"
                        target="_blank">
                        <u>
                          מדריך מוסמך של האירגון הבינלאומי AIDA
                        </u>

                      </a>
                      <br>
                      <br>
                      052-663-0434
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="animationRope2">
              <div id="background-rope2"></div>
            </div>
            <div id="liens">
              <a href="https://www.facebook.com/Freediving-Galilee-115345037845955"><img
                  src="../../static/img/logoFacebook.png" /></a>
              <!--  <a href="https://www.instagram.com/apneaclubgeneve/"
                ><img src="../../static/img/logoInstagram.png"
              /></a> -->
              <div id="weight"></div>
              <!-- <div id="linkRuttar">
                concept and design by
                <span id="ruttarBold"
                  ><a href="http://www.ruttar.ch/">ruttar.ch</a></span
                >
              </div> -->
            </div>
            <div class="transparentLast"></div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  // created() {
  //   window.addEventListener("scroll", this.handleScroll(window.scrollY));
  // },
  data() {
    return {
      showImageSelected: false,
      windowTop: "",
      title: "general",
      userKey: "",
      language: "Français",
      isFixed: true,
      countDown: "",
      lang: "he",
      src: "",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
  },

  methods: {
    backToTop() {
      setTimeout(() => {
        this.isFixed = true;
      }, 3000);
      clearInterval(this.countDown);
    },
    openImage(image) {
      console.log(this.$refs[image]);
      this.$refs[image].classList.toggle("showImage");
    },
    clearCountDown() {
      clearInterval(this.countDown);
      console.log("this.countDown", this.countDown);
    },
    countSeconds(min, sec, mili) {
      console.log("tmin, sec, mili", min, sec, mili);

      this.countDown = setInterval(() => {
        if (mili == 99) {
          sec++;
          mili = 0;
        }
        if (sec == 59 && mili == 1) {
          min++;
          sec = 0;
        }
        mili++;
        if (sec > 9) {
          if (mili > 9) {
            document.getElementById("timer").innerHTML =
              "0" + min + ":" + sec + ":" + mili;
          } else {
            document.getElementById("timer").innerHTML =
              "0" + min + ":" + sec + ":0" + mili;
          }
        } else {
          if (mili > 9) {
            document.getElementById("timer").innerHTML =
              "0" + min + ":" + "0" + sec + ":" + mili;
          } else {
            document.getElementById("timer").innerHTML =
              "0" + min + ":" + "0" + sec + ":0" + mili;
          }
        }
      }, 10);
    },
    onScroll(e) {
      var w = window.innerWidth;
      this.windowTop = e.target.documentElement.scrollTop;
      // console.log("windowTop", this.windowTop);
      if (w < 550) {
        if (this.windowTop < 3230) {
          document.getElementById("leClubMenu").classList.add("underline");
        } else {
          document.getElementById("leClubMenu").classList.remove("underline");
        }

        if (this.windowTop > 3231 && this.windowTop < 4880) {
          document.getElementById("activitesMenu").classList.add("underline");
        } else {
          document
            .getElementById("activitesMenu")
            .classList.remove("underline");
        }

        // if (this.windowTop > 4881 && this.windowTop < 5880) {
        //   document.getElementById("galerieMenu").classList.add("underline");
        // } else {
        //   document.getElementById("galerieMenu").classList.remove("underline");
        // }
        if (this.windowTop > 5881 && this.windowTop < 7000) {
          document.getElementById("contactMenu").classList.add("underline");
        } else {
          document.getElementById("contactMenu").classList.remove("underline");
        }
      } else {
        if (this.windowTop < 3490) {
          document.getElementById("leClubMenu").classList.add("underline");
        } else {
          document.getElementById("leClubMenu").classList.remove("underline");
        }

        if (this.windowTop > 3490 && this.windowTop < 5000) {
          document.getElementById("activitesMenu").classList.add("underline");
        } else {
          document
            .getElementById("activitesMenu")
            .classList.remove("underline");
        }

        // if (this.windowTop > 5085 && this.windowTop < 5740) {
        //   document.getElementById("galerieMenu").classList.add("underline");
        // } else {
        //   document.getElementById("galerieMenu").classList.remove("underline");
        // }
        // if (this.windowTop > 5740 && this.windowTop < 8000) {
        //   document.getElementById("contactMenu").classList.add("underline");
        // } else {
        //   document.getElementById("contactMenu").classList.remove("underline");
        // }

        if (this.windowTop > 5001 && this.windowTop < 5740) {
          document.getElementById("contactMenu").classList.add("underline");
        } else {
          document.getElementById("contactMenu").classList.remove("underline");
        }
      }
    },
    scrollMeTo(yScroll) {
      window.scrollTo({
        top: yScroll,
        left: 0,
        behavior: "smooth",
      });
    },
    showContent(item) {
      // console.log(this.$refs[item]);
      this.$refs[item].classList.toggle("showContent");
      this.$refs[item].classList.toggle("hideContent");
    },
    showContentOnClick(item1, item2) {
      this.$refs[item1].classList.remove("showContent");
      this.$refs[item2].classList.add("hideContent");
      this.$refs[item1].classList.add("hideContent");
      this.$refs[item2].classList.remove("showContent");
      setTimeout(() => {
        this.$refs[item1].classList.add("showContent");
        this.$refs[item2].classList.remove("hideContent");
        this.$refs[item1].classList.remove("hideContent");
        this.$refs[item2].classList.add("showContent");
      }, 2500);
    },
    switchLangToFrench() {
      this.$store.dispatch("switchLangToFrench");
    },
    switchLangToEnglish() {
      this.$store.dispatch("switchLangToEnglish");
    },
    translate(lang) {
      switch (lang) {
        case "fr":
          this.translation = {
            stamp: "Jeu de piste",
            beware: "Attention!",
            startPoint: "Le jeu commence à la place de Meyrin Village",
            letsGoButton: "ON Y EST!",
            beforeStarting:
              "Avant de se lancer, vous pouvez rapidement recevoir quelques explications sur le fonctionnement de l'application.",
            ok: "Ca marche!",
            skip: "Non merci, passer",
            noPassword:
              "Il semblerait que vous avez oublié d'entrer un pseudo... C'est juste pour que vous puissiez voir à quelle place vous avez fini au classement.",
            gotIt: "Ok, j'ai compris",
          };
          console.log("french");
          break;
        case "en":
          this.translation = {
            stamp: "Jeu de piste",
            beware: "Attention!",
            startPoint: "The game begins at the Place of Meyrin Village",
            letsGoButton: "I'M HERE!",
            beforeStarting:
              "Before getting started, you can learn how the app works.",
            ok: "Sure!",
            skip: "No thanks, skip.",
            noPassword:
              "It looks like you forgot to enter a nickname... It's just so you can see where you ended up in the leaderboard.",
            gotIt: "Ok, got it",
          };
          console.log("english");

          // code block
          break;
        case "he":
          this.translation = {
            stamp: "משחק ניווט",
            beware: "שימו לב!",
            startPoint: "המשחק מתחיל שם",
            letsGoButton: "אני כאן!",
            beforeStarting: "לפני שמתחילים, תראו איך זה עובד",
            ok: "בטח!",
            skip: "לא תודה",
            noPassword: "זה נראה ששכת להכניס כינוי",
            gotIt: "טוב בסדר",
          };
          console.log("english");

          // code block
          break;
        default:
        // code block
      }
    },
    startGame() {
      this.$router.push("/startGame");
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
  },
};
</script>

<style scoped>
#logo img:first-of-type {
  visibility: visible;
}

/* #logo img:last-of-type {
  visibility: hidden;
  position: absolute;
} */
.courseDetails {
  margin-top: 12px;
}

.rtl {
  direction: rtl;
}

.showImage {
  width: 90vw;
  position: fixed;
  top: 5vh;
  left: 5vw;
  height: auto !important;
  z-index: 999;
}

#showImage img {
  width: 100%;
}

.fullImage {
  height: 100%;
  width: auto;
}

.underline {
  border-bottom: 2px solid white;
}

.rowMesures {
  width: 100vw;
  color: white;
  max-width: 1024px;
  margin: 0 auto;
  text-align: center;
}

.rowMesuresData {
  font-size: 20px;
  width: 100vw;
  color: white;
  max-width: 1024px;
  margin: 0 auto;
  text-align: center;
  border-top: 1px solid;
  padding-top: 8px;
}

.fadeInUp {
  position: relative;
  animation-duration: 3s;
  animation-delay: 2s;
  animation-name: fadeInUp;
  animation-timing-function: ease-out;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    bottom: -150vh;

    -webkit-transform: translate3d(0, 30%, 0);
    -ms-transform: translate3d(0, 30%, 0);
    transform: translate3d(0, 30%, 0);
  }

  80% {
    bottom: 20px;
  }

  93% {
    bottom: -10px;
  }

  100% {
    bottom: 0px;
    opacity: 1;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
  }
}

.middleRight {
  margin-right: calc(50% + 56px);
  direction: rtl;
}

.middleLeft {
  margin-left: calc(50% + 45px);
}

.sectionTitle {
  overflow: hidden;
}

.hideContent {
  position: relative;
  bottom: 900px;
  transition: all 1s;
}

.showContent {
  position: relative;
  bottom: 0px;
  transition: all 1s;
}

.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
  border-radius: 36px;
  height: 56px;
  color: white;
}

.myModal {
  display: block;
  margin: 0px auto;
}

#titleMainPage {
  position: relative;
  font-size: 70px;
  color: white;
  background: 50% 100% / 50% 50% no-repeat
    radial-gradient(ellipse at bottom, #fff, transparent, transparent);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: reveal 1000ms ease-in-out forwards 200ms,
    glow 2500ms linear infinite 2000ms;
}

.main {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  top: 52px;
  position: relative;
}

.moveTitle {
  animation-duration: 3s;
  animation-name: slidein;
}

.title {
  font-family: "Righteous", cursive;
  font-size: 70px;
  color: #cf1110;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.ltr {
  direction: ltr;
  text-align: left;
}

.myModal2 {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  background-color: rgb(84, 163, 49);
  color: white;
  border: solid 2px white;
}

.over {
  position: fixed;
  top: 0px;
  font-size: 18px;
  width: 100vw;
  height: 100vh;
  background: url("../../static/videos/lacCalme.mp4") no-repeat center center;
  background: black;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.9);
}

.colorBtn {
  border-radius: 36px;
  color: rgb(84, 163, 49);
  margin: 0px auto;
  margin-top: 30px;
  background-color: white;
  padding-top: 14px;
}

.center {
  display: block;
  margin: 0px auto;
}

@keyframes reveal {
  80% {
    letter-spacing: 8px;
  }

  100% {
    background-size: 300% 300%;
  }
}

@keyframes glow {
  40% {
    text-shadow: 0 0 8px #fff;
  }
}

@keyframes stamp {
  0% {
    opacity: 0;
  }

  70% {
    opacity: 0;
  }

  85% {
    opacity: 0;
  }

  93% {
    opacity: 0;
  }

  94% {
    opacity: 0.5;
    transform-origin: 50% 50%;
    transform: scale(4);
    transition: all 0.1s cubic-bezier(0.6, 0.04, 0.98, 0.335);
  }

  100% {
    opacity: 1;
    transform: rotate(-20deg) scale(1);
  }
}

@keyframes animate {
  0% {
    opacity: 0;
    background-position: -500%;
    background-size: 80%;
  }

  20% {
    opacity: 1;
    background-position: 400%;
    background-size: 80%;
  }

  40% {
    background-position: -200%;
    background-size: 80%;
  }

  60% {
    background-position: 0%;
    background-size: 80%;
  }

  80% {
    background-position: 0%;
    background-size: 100%;
  }

  100% {
    background-position: 0%;
  }
}

@keyframes appear {
  0% {
    opacity: 0;
  }

  30%,
  70% {
    opacity: 0;
  }

  90% {
    opacity: 1;
  }

  93% {
    opacity: 0.5;
  }

  95% {
    opacity: 1;
    transform: scale(1.05);
  }

  98% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@keyframes slidein {
  0% {
    margin-left: 120vw;
  }

  72% {
    margin-left: 120vw;
  }

  98% {
    margin-left: 3%;
  }

  to {
    margin-left: 0%;
  }
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;

  padding: 0;

  border: 0;

  font-size: 100%;

  font: inherit;

  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";

  content: none;
}

table {
  border-collapse: collapse;

  border-spacing: 0;
}

#loading {
  font-size: 4em;
  text-align: center;
  position: absolute;
  top: 60vh;
  color: white;
  width: 100%;
}

body {
  font-family: "raleway";
}

body.home {
  overflow: hidden;
}

#welcomePage {
  background: rgba(0, 0, 0, 0.5);
  background-size: cover;
  height: 100vh;
  z-index: 22;
  position: relative;
  background-color: black;
}

#fullscreen-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  /* top: -10px; */
  top: -5px !important;
  left: -5px;
  overflow: hidden !important;
}

.fullscreen-bg video {
  min-width: 100%;
  min-height: 100%;
  overflow: hidden !important;
}

/*.fullscreen-bg {      
    overflow: hidden;
    z-index: -100;
}

.fullscreen-bg__video { 
   width: 100%;
   height: 100%;    
}*/

#logoWelcome img {
  position: absolute;
  right: calc(50vw - 225px);
  top: 168px;
  display: block;
  width: 450px;
  padding-top: 50px;
}

#diveIn {
  position: absolute;
  right: calc(50vw - 45px);
  bottom: 100px;
  font-weight: lighter;
  font-size: 60px;
  color: #fff !important;
  background: rgba(0, 0, 0, 0);
  cursor: pointer;
  text-decoration: none;
}

#diveIn:after {
  background: url("../../static/img/arrowLeft2.png");
  position: absolute;
  content: "";
  bottom: -50px;
  right: 49px;
  height: 25px;
  width: 39px;
  transform: rotate(-90deg);
  cursor: pointer;
}

#info {
  position: relative;
}

div.info {
  display: inline-block;
}

#allInfo {
  position: fixed;
  top: 112px;
  display: block;
  width: 100%;
  height: 38px;
  z-index: 20;
  left: 0px;
  padding-left: 36%;
  background: rgba(0, 0, 0, 0.9);
}

#pression {
  padding: 5px;
}

#meters {
  padding: 10px;
}

.info {
  margin-left: 30px;
  position: relative;
  font-size: 17px;
  color: #fff;
  width: 180px;
  left: 0px;
  top: 0px;
  z-index: 20;
}

h1 {
  height: 30px;
  left: 0px;
  top: 112px;
  /* display: none; */
  width: 200px;
  position: fixed;
  color: #fff;
  font-size: 30px;
  padding: 5px;
  position: fixed;
  z-index: 21;
  padding-left: 21%;
}

#wrapper {
  width: auto;
  font-family: "raleway";
}

#background-rope {
  height: 6300px;
  /* height: 7092px; */

  /*background: url('images/singleRope.jpg');
	width: 25px;*/
  background: white;
  width: 5px;
  position: absolute;
  top: 0px;
  right: 50%;
}

#background-rope2 {
  display: none;
  height: 330px;
  background: white;
  width: 5px;
  position: absolute;
  top: -175px;
  right: 50%;
}

@keyframes animationRope {
  0% {
    left: 0px;
    top: 0px;
  }

  100% {
    left: 0px;
    top: 25px;
  }
}

#animationRope {
  animation-name: animationRope;
  position: relative;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease;
}

#animationRope2 {
  animation-name: animationRope;
  position: relative;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease;
}

#mesure {
  left: 10px;
  background: url("../../static/img/mesure.png");
  /* height: 7300px; */
  height: 6380px;

  position: absolute;
  top: 130px;
  width: 50px;
  animation-name: animationRope;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease;
}

/*/////////////////

/*HEADER/

//////////////////*/

.star {
  height: 16px;
  width: 35px;
  position: absolute;
  left: 41px;
  display: block;
  z-index: 20;
  background-color: red;
}

#CM1 {
  top: 8479px;
}

#RR1 {
  top: 8400px;
}

#CM2 {
  top: 7923px;
}

#CM3 {
  top: 6553px;
}

#RR2 {
  top: 6400px;
}

#RR3 {
  top: 6844px;
}

#HH1 {
  top: 9155px;
}

#PB1 {
  top: 6938px;
}

#PB2 {
  top: 6000px;
}

#PB3 {
  top: 7000px;
}

#PB4 {
  top: 10788px;
}

.star span {
  opacity: 0;
  filter: alpha(opacity=000);
  /* For IE8 and earlier */
  color: black;
  width: 450px;
  background: rgba(225, 225, 225, 0.8);
  transition: 0.5s;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  position: absolute;
  top: 3px;
  left: -80px;
  border-radius: 20px;
  padding: 5px;
  font-size: 13px;
}

.star:hover span {
  opacity: 1;
  filter: alpha(opacity=100);
  /* For IE8 and earlier */
  left: 50px;
}

.star img {
  height: 30px;
}

#full-width-one {
  background: rgba(0, 0, 0, 0.9);
  width: 100%;
  position: fixed;
  /*transition: 1s;
    -webkit-transition: 1s;
	-moz-transition: 1s;*/
  z-index: 21;
  height: 185px;
  top: 0px;
}

#full-width-one.fixed,
.category-news #full-width-one,
.single-post #full-width-one {
  position: fixed;
  top: 0;
}

.fixed {
  position: fixed !important;
  height: 100%;
  width: 100%;
  overflow: hidden;
  top: -5px !important;
  left: -5px;
}

#header {
  background: rgba(0, 0, 0, 0);
  /*position: relative;*/
  height: 110px;
  margin: 0px auto;
  width: 1024px;
  z-index: 20;
  display: block;
}

#header div,
nav {
  display: inline-block;
}

#navigation {
  height: 20px;
  list-style-type: none;
  font-size: 18px;
}

header div {
  vertical-align: middle;
  margin: 0px auto;
  display: block;
}

header div img {
  padding-top: 10px;
  padding-bottom: 10px;
  vertical-align: middle;
  margin: 0px auto;
  display: block;
  cursor: pointer;
  width: 150px;
}

#menu li {
  display: inline-block;
  margin-left: 82px;
  position: relative;
}

#menu li a {
  text-decoration: none;
  text-transform: uppercase;
  -moz-text-transform: uppercase;
  -webkit-text-transform: uppercase;
  color: #fff;
}

/* #menu li:last-child a {
  color: black;
} */

/* #menu li:last-child {
  margin-right: auto;
  padding: 9px;
  color: black;
  background-color: #fff;
  border-radius: 5px;
  border-color: red;
  border-width: 2px;
  border-style: solid;
} */

#menu li a.selected:after {
  /*text-decoration: underline;*/
  position: absolute;
  height: 1px;
  margin: 0 auto;
  content: "";
  width: 100%;
  color: #fff;
  background-color: #fff;
  left: 0;
  bottom: -4px;
  /* adjust this to move up and down. you may have to adjust the line height of the paragraph if you move it down a lot. */
}

#menu {
  vertical-align: middle;
  margin-left: 110px;
  /*transition:0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;*/
}

/*//////////////////
/*MAIN
//////////////////*/

#background-image-one {
  /*background: url('../../static/img//fond_eau_clean-01.png') no-repeat top center ;

	background-size: cover;*/
  background: linear-gradient(to bottom, #0075bf, #05000b);
}

.transparent {
  width: auto;
  height: 1200px;
  background: rgba(0, 0, 30, 0);
}

.transparentLast {
  width: auto;
  height: 400px;
  background: rgba(0, 0, 30, 0);
  z-index: -10;
}

/*//////////////////

SECTIONONE

////////////////////*/

.bubble p {
  padding-top: 50px;
  padding-bottom: 30px;
  font-weight: bold;
}

/*.bubble {
	position: absolute;
	text-align: center;
	color: #fff;
	background: radial-gradient(circle at 80px 80px, #5cabff, #000);
	width: 300px;	
	overflow: hidden; 
	height: 200px;
	border-radius: 200px;
	cursor: pointer;
	border-style: solid;
	border-width: 2px;
	border-color: #fff;
	transition: 0.5s;
	-webkit-transition: 0.5s;
	-moz-transition: 0.5s;
	margin-left: 20px;
	margin-top: 10px;
	animation-name: movingImages;
	animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: ease;

}*/

.ball {
  display: inline-block;
  text-align: center;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  position: absolute;
  background: radial-gradient(
    circle at bottom,
    #81e8f6,
    #76deef 10%,
    #055194 80%,
    #062745 100%
  );
}

.ball:before {
  content: "";
  position: absolute;
  top: 1%;
  left: 5%;
  width: 90%;
  height: 90%;
  border-radius: 100%;
  background: radial-gradient(circle at top, white, rgba(255, 255, 255, 0) 58%);
  -webkit-filter: blur(5px);
  filter: blur(5px);
  z-index: 2;
}

.ball:after {
  content: "";
  position: absolute;
  display: none;
  top: 5%;
  left: 10%;
  width: 80%;
  height: 80%;
  border-radius: 100%;
  -webkit-filter: blur(1px);
  filter: blur(1px);
  z-index: 2;
  -webkit-transform: rotateZ(-30deg);
  transform: rotateZ(-30deg);
}

.ball .shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.1) 40%,
    rgba(0, 0, 0, 0) 50%
  );
  -webkit-transform: rotateX(90deg) translateZ(-160px);
  transform: rotateX(90deg) translateZ(-160px);
  z-index: 1;
}

.ball.plain {
  background: black;
}

.ball.plain:before,
.ball.plain:after {
  display: none;
}

.ball.bubble {
  background: radial-gradient(
    circle at 50% 55%,
    rgba(240, 245, 255, 0.9),
    rgba(240, 245, 255, 0.9) 40%,
    rgba(225, 238, 255, 0.8) 60%,
    rgba(43, 130, 255, 0.4)
  );
  -webkit-animation: bubble-anim 3s ease-out infinite;
  animation: bubble-anim 3s ease-out infinite alternate;
}

.ball.bubble:before {
  -webkit-filter: blur(0);
  filter: blur(0);
  height: 80%;
  width: 40%;
  background: radial-gradient(
    circle at 130% 130%,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0) 46%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 58%,
    rgba(255, 255, 255, 0) 60%,
    rgba(255, 255, 255, 0) 100%
  );
  -webkit-transform: translateX(131%) translateY(58%) rotateZ(168deg)
    rotateX(10deg);
  transform: translateX(131%) translateY(58%) rotateZ(168deg) rotateX(10deg);
}

.ball.bubble:after {
  display: block;
  background: radial-gradient(
    circle at 50% 80%,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0) 74%,
    white 80%,
    white 84%,
    rgba(255, 255, 255, 0) 100%
  );
}

.stage {
  width: 200px;
  height: 200px;
  display: inline-block;
  margin: 20px;
  -webkit-perspective: 1200px;
  -moz-perspective: 1200px;
  -ms-perspective: 1200px;
  -o-perspective: 1200px;
  perspective: 1200px;
  -webkit-perspective-origin: 50% 50%;
  -moz-perspective-origin: 50% 50%;
  -ms-perspective-origin: 50% 50%;
  -o-perspective-origin: 50% 50%;
  perspective-origin: 50% 50%;
  position: absolute;
  left: 0;
  top: 0;
}

/*body {
  width: 300px;
  margin: 20px auto;
  background: linear-gradient(to bottom, rgba(100, 100, 100, 0.2) 0%, rgba(255, 255, 255, 0.5) 40%, #ffffff 100%);
  background-repeat: no-repeat;
}*/

@-webkit-keyframes bubble-anim {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    left: 0px;
    top: 60px;
  }

  20% {
    -webkit-transform: scaleY(0.95) scaleX(1.05);
    transform: scaleY(0.95) scaleX(1.05);
  }

  48% {
    -webkit-transform: scaleY(1.08) scaleX(0.95);
    transform: scaleY(1.08) scaleX(0.95);
  }

  68% {
    -webkit-transform: scaleY(0.98) scaleX(1.02);
    transform: scaleY(0.98) scaleX(1.02);
  }

  80% {
    -webkit-transform: scaleY(1.02) scaleX(0.98);
    transform: scaleY(1.02) scaleX(0.98);
  }

  97%,
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    left: 0px;
    top: -50px;
  }
}

@keyframes bubble-anim {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    left: 0px;
    top: 60px;
  }

  20% {
    -webkit-transform: scaleY(0.95) scaleX(1.05);
    transform: scaleY(0.95) scaleX(1.05);
  }

  48% {
    -webkit-transform: scaleY(1.08) scaleX(0.95);
    transform: scaleY(1.08) scaleX(0.95);
  }

  68% {
    -webkit-transform: scaleY(0.98) scaleX(1.02);
    transform: scaleY(0.98) scaleX(1.02);
  }

  80% {
    -webkit-transform: scaleY(1.02) scaleX(0.98);
    transform: scaleY(1.02) scaleX(0.98);
  }

  97%,
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    left: 0px;
    top: -50px;
  }
}

section.current h1 {
  display: block;
}

section {
  width: 1084px;
  margin: 0 auto;
  position: relative;
  background: rgba(0, 0, 30, 0);
}

#leClub {
  height: 500px;
}

.droite p {
  position: relative;
}

.imgDroite {
  height: 213px;
  width: 485px;
  overflow: hidden;
  position: relative;
  top: 42px;
  right: 562px;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
}

.imgAll {
  height: auto;
  width: 485px;
  overflow: hidden;
  position: relative;
  /* padding-right: 26px; */
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  object-fit: cover;
}

.imgGauche {
  height: 360px;
  width: 485px;
  overflow: hidden;
  position: absolute;
  top: 43px;
  left: 553px;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
}

.imgDroite img {
  width: 484px;
}

.imgGauche img {
  width: 641px;
}

#competitions .imgDroite {
  height: 306px;
}

#competitions .imgDroite img {
  width: 484px;
}

#entrainementsPiscine .imgDroite img {
  width: 850px;
  align-content: center;
}

#entrainementsPiscine .imgDroite {
  height: 617px;
}

#sortiesLac .imgGauche img {
  width: 527px;
  align-content: center;
}

#sortiesLac .imgGauche {
  height: 297px;
}

#autres .imgGauche img {
  width: 929px;
  align-content: center;
}

#autres .imgGauche {
  height: 522px;
}

.droite > div a {
  text-decoration: none;
  color: #fff;
  font-style: italic;
}

.droite {
  color: #fff;
  font-size: 23px;
  text-align: left;
  /*transition:0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;*/
  /* position: relative;
  margin-left: 51%;
  width: 45%; */
  font-weight: normal;
  min-height: 130px;
  margin-bottom: 30px;
}

.droite h2:before {
  content: url("../../static/img/arrowRight2.png");
  height: 30px;
  width: 15px;
  left: -26px;
  top: -1px;
  position: absolute;
  transition: 0.4s;
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
}

.droite.active h2:before {
  transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

/*.droite.active .imgDroite{
	transform: translate(-600px,30px);
	-moz-transform: translate(-600px,30px);
	-webkit-transform: translate(-600px,30px);
	opacity: 1;
}*/

/*le #news .droite:nth-child(2n+1) c'est pour faire d'un .droite un point gauche en jouant avec le pair et impair*/

#news .droite:nth-child(2n + 1) {
  color: #fff;
  font-size: 23px;
  text-align: right;
  /*transition:0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;*/
  position: relative;
  width: 45%;
  font-weight: normal;
  padding-right: 30px;
  height: auto;
  margin-left: 0px;
  padding-left: 0px;
  min-height: 130px;
  margin-bottom: 30px;
}

.gauche {
  color: #fff;
  font-size: 23px;
  text-align: right;
  position: relative;
  font-weight: normal;
}

.gauche h2:after,
#news .droite:nth-child(2n + 1) h2:after {
  content: url(../../static/img/arrowLeft2.png);
  height: 30px;
  width: 15px;
  right: -30px;
  top: 0px;
  position: absolute;
  transition: 0.4s;
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
  left: inherit;
}

.gauche.active h2:after,
#news .droite.active:nth-child(2n + 1) h2:after {
  transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
}

.animated {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.g_v_d {
  -webkit-animation-name: apparition_gauche_vers_droite;
  animation-name: apparition_gauche_vers_droite;
}

@keyframes apparition_gauche_vers_droite {
  0% {
    opacity: 0;
    -webkit-transform: translate(0px, 500px);
    -ms-transform: translate(0px, 500px);
    transform: translate(0px, 500px);
  }

  100% {
    opacity: 1;
    -webkit-transform: translate(0px, 0px);
    -ms-transform: translate(0px, 0px);
    transform: translate(0px, 0px);
  }
}

h2 {
  cursor: pointer;
  position: relative;
  font-size: 20px;
}

.droite > div p,
.gauche > div p {
  margin-bottom: 10px;
}

.clear {
  clear: both;
}

.inline {
  width: 1024px;
  margin: 0 auto;
}

.droite > div,
.gauche > div {
  color: #fff;
  display: block;
  height: auto;
  font-size: 15px;
  padding-top: 20px;
  font-weight: normal;
  line-height: 1.7em;
  margin-bottom: 20px;
}

/* 
.gauche > div {
  margin-left: 40px;
} */

.droite ul {
  list-style-type: circle;
  list-style-position: inside;
}

/*//////////////////////

 SECTIONTWO

///////////////////////*/

#activites {
  background: rgba(0, 0, 30, 0);
  /* height: 3200px; */
  margin: 0 auto;
  position: relative;
}

#palmares .apneiste {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  padding: 5px;
  width: 90%;
  text-align: left;
  border-style: solid;
  border-width: 1px;
  border-color: #fff;
  transition: 0.4s;
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
  height: 15px;
}

/* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */

#palmares.apneiste:hover {
  background: red;
}

/* Style the accordion panel. Note: hidden by default */

div.resultats {
  padding: 0 18px;
  background: rgba(255, 255, 255, 0.2);
  display: none;
  height: 100%;
  color: #fff;
  width: 80%;
  font-size: 12px;
  line-height: 1.1em;
  font-weight: 300;
}

.resultats li {
  margin-bottom: 3px;
}

.resultats p {
  line-height: 1.4em;
}

/*////////////////////
GALERIE
//////////////////////*/

#galerie {
  height: 800px;
}

#galerie .image {
  float: right;
}

@keyframes movingImages {
  0% {
    left: 0px;
    top: -100px;
  }

  100% {
    left: 0px;
    top: 30px;
  }
}

@keyframes movingImages2 {
  0% {
    left: 0px;
    top: -80px;
  }

  100% {
    left: 0px;
    top: 50px;
  }
}

@keyframes movingImages3 {
  0% {
    left: 0px;
    top: -200px;
  }

  100% {
    left: 0px;
    top: 60px;
  }
}

.image {
  width: 100px;
  overflow: hidden;
  /*TRES IMPORTANT POUR CACHER*/
  height: 100px;
  border-radius: 300px;
  cursor: pointer;
  border-style: solid;
  border-width: 2px;
  border-color: #fff;
  transition: 0.5s;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  margin-left: 20px;
  margin-top: 10px;
  animation-name: movingImages;
  position: relative;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease;
}

.image:nth-child(2n + 1) {
  animation-name: movingImages2;
  animation-duration: 5s;
  -webkit-animation-delay: 2s;
  /* Safari 4.0 - 8.0 */
  animation-delay: 2s;
}

.image:nth-child(3n + 1) {
  animation-name: movingImages3;
  animation-duration: 8s;
  -webkit-animation-delay: 3s;
  /* Safari 4.0 - 8.0 */
  animation-delay: 2s;
}

.image img {
  transition: 0.5s;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  height: 105px;
}

.alignCenter {
  padding-top: 200px;
  /*margin-left: 35px;*/
}

/*.contImgTitleRight div, .contImgTitleLeft div{
	display: inline-block;
	vertical-align: middle;	
}


.imgTitleRight, .imgTitleLeft {
	width: 300px;
	height: 30px;
	position: relative;
}

.imgTitleRight h2 {
	color: #fff;
	font-size: 23px;
	display: none;
	text-align: left;
	padding-left: 20px;
}

.imgTitleLeft h2 {
	color: #fff;
	font-size: 23px;
	display: none;
	text-align: right;
	padding-right: 20px;
}*/

/*/////////////////////
NEWS
////////////////////*/

#news {
  height: auto;
  padding-bottom: 100px;
}

#news .gauche a {
  text-decoration: none;
  color: #fff;
}

.liste_news .droite img {
  height: 120px;
  position: absolute;
  top: 0px;
  right: 500px;
}

.liste_news .droite:nth-child(2n + 1) img {
  top: 0px;
  left: 556px;
  right: inherit;
}

#news .droite:nth-child(2n + 1) h2:before {
  display: none;
}

/*/////////////////

///FORMULAIRE

/////////////////*/

#contact {
  height: 800px;
}

form {
  border-color: #fff;
  border-style: solid;
  border-width: 1px;
  padding: 10px;
  width: 350px;
  height: auto;
  margin-top: 20px;
  font-size: 15px;
}

#contact form p {
  display: block;
  margin-bottom: 15px;
}

.boxForm {
  width: 300px;
  font-size: 15px;
}

h3 {
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 10px;
  /*background: rgba(0,0,0,0.1);*/
}

#liens {
  animation-name: animationRope;
  position: relative;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  position: relative;
  animation-direction: alternate;
  animation-timing-function: ease;
  border-width: 1px;
  border-style: solid;
  position: relative;
  left: 0px;
  top: 0px;
  border-color: #fff;
  width: 200px;
  height: 8px;
  align-content: center;
  margin: 0 auto;
}

#liens img {
  height: 30px;
  padding-top: 0px;
  margin-left: 68px;
  top: -38px;
  left: -31px;
  position: relative;
}

#linkRuttar {
  margin: 0 auto;
  color: #fff;
  text-align: center;
  line-height: 1.4;
  margin-top: 10px;
  cursor: pointer;
  z-index: 500;
  position: relative;
  top: 150px;
}

#weight {
  margin: 0 auto;
  color: #fff;
  /* text-align: center; */
  /* line-height: 1.4; */
  /* margin-top: 10px; */
  cursor: pointer;
  /* z-index: 500; */
  position: relative;
  top: 108px;
  border: 13px solid;
  height: 114px;
  width: 33px;
  left: -2px;
}

#ruttarBold a {
  font-size: 30px;
  font-weight: lighter;
  color: white;
  text-decoration: none;
}

#google_map div {
  display: block;
}

#google_map {
  display: block;
}

.slicknav_menu {
  display: block;
}

/*///////////////////
PAGE NEWS
///////////////*/

#wrapperNews {
  background: url("../../static/img/back-image-one.jpeg") center center
    no-repeat fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  font-family: "raleway";
  min-height: 100vh;
  height: 100%;
}

#news {
  font-family: "raleway";
}

#pageNews {
  width: 1024px;
  margin: 0 auto;
  padding-top: 150px;
}

#pageSingleArticle {
  width: 1024px;
  margin: 0 auto;
  padding-top: 150px;
  height: 100%;
}

#article {
  margin: 0 auto;
  width: 80%;
  height: auto;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.9);
  color: black;
  padding: 15px;
  border-style: solid;
  border-width: 5px;
  border-color: grey;
  position: relative;
}

#singleArticle {
  margin: 0 auto;
  width: 80%;
  height: auto;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.9);
  color: black;
  padding: 15px;
  border-style: solid;
  border-width: 5px;
  border-color: grey;
  position: relative;
}

#article h2 {
  font-size: 30px;
  margin-bottom: 20px;
}

#article p {
  float: right;
  width: 65%;
  margin-bottom: 20px;
  line-height: 1.4em;
}

#article a {
  position: absolute;
  left: 36%;
  bottom: 11px;
}

#article .suite {
  vertical-align: bottom;
}

#article .suite a {
  vertical-align: bottom;
  text-decoration: none;
  font-weight: bold;
  color: black;
}

#article img {
  height: 150px;
}

#clear {
  clear: both;
}

#article .imgNews {
  height: 100px;
}

.imgNews {
  margin-bottom: 20px;
  overflow: hidden;
}

#news .droite {
  width: 39%;
}

@media screen and (max-width: 1400px) {
  #allInfo {
    padding-left: 33%;
  }

  h1 {
    padding-left: 15%;
  }
}

@media screen and (max-width: 1300px) {
  #allInfo {
    padding-left: 32%;
  }

  h1 {
    padding-left: 13%;
  }
}

@media screen and (max-width: 1200px) {
  #mesure {
    left: 0px;
    width: 30px;
    animation-name: animationRope;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: ease;
    margin-left: 0px;
  }
}

@media screen and (max-width: 1100px) {
  #header {
    max-width: 95vw;
  }

  section {
    max-width: 95vw;
  }

  #menu {
    margin-left: 50px;
  }

  #menu li {
    margin-left: 40px;
  }

  .imgAll {
    width: 40vw;
  }

  .middleLeft {
    margin-left: 53vw;
  }

  .middleRight {
    margin-right: 53vw;
  }

  .showContent > div {
    max-width: 49vw;
  }

  .star {
    left: 11px;
  }

  #allInfo {
    padding-left: 29%;
  }

  h1 {
    padding-left: 6%;
  }

  h2 {
    font-size: 20px;
  }

  #news h2 {
    font-family: "raleway";
    font-size: 18px;
  }

  .gauche h3,
  .gauche p {
    text-align: right;
    margin-right: 0px;
  }

  #mesure {
    left: -20px;
    width: 30px;
  }
}

@media screen and (max-width: 800px) {
  .inline {
    width: 100vw;
  }

  section {
    max-width: 90vw;
  }

  .stage {
    display: none;
  }

  #menu li {
    margin-left: 18px;
  }

  #menu {
    margin-left: 0px;
  }

  .middleLeft {
    margin-left: calc(50vw);
  }

  #navigation {
    padding: 0px;
    font-size: 16px;
  }
}

@media screen and (max-width: 700px) {
  /* #logo {
    right: 27%;
  } */
  /* form {
    margin-bottom: 30px;
  } */
  #logo img {
    width: 90px !important;
    padding-top: 14px;
    margin-left: 80px;
  }

  header div img {
    width: 130px !important;
    padding-top: 14px;
  }
}

@media screen and (max-width: 550px) {
  #logo img:first-of-type {
    visibility: hidden;
    position: absolute;
  }

  #logo img:last-of-type {
    visibility: visible;
    position: relative;
  }

  #background-rope2 {
    display: block;
  }

  #background-rope {
    top: 6040px;
    height: 322px;
    display: none;
  }

  #logo {
    right: 76px;
  }

  /* .info {
    margin-left: 0px;
  } */

  .section_home div {
    width: 250px;
  }

  h2 {
    font-size: 18px;
  }

  form {
    width: 225px;
  }

  form input,
  form textarea {
    width: 220px;
  }

  .droite > div p,
  .gauche > div p {
    margin-right: 8px;
    text-align: right;
  }

  .hideContent {
    bottom: 1000px;
  }

  .gauche > div img {
    display: none;
  }

  .gauche h2:before {
    display: none;
  }

  .droite h2:before {
    display: none;
  }

  .middleRight {
    margin-left: 0px;
    text-align: right;
    margin-right: 35px;
  }

  .middleLeft {
    margin-left: 0px;
    padding-right: 38px;
  }

  h3 {
    margin-right: 8px;
  }

  .gauche h2:after {
    content: url(../../static/img/arrowLeft2.png);
    height: 30px;
    width: 15px;
    right: -30px;
    top: 0px;
    position: absolute;
    transition: 0.4s;
    -webkit-transition: 0.4s;
    -moz-transition: 0.4s;
    left: inherit;
  }

  .droite h2:after {
    content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QIOEiwh4SlKOgAAAHxJREFUOMvt1LENg0AQRNG/RBdSAiVQGp1cKYQOrwRaoYIZEsuyZUvHOiBisgueVqfVDiRie5RUIwNsN2AfMiAiZoAhC7roFwD23qc3v+X5Hm/wNwCQVP2dqbfxIumRmnTDi+F65tQ/oKR2tlReUFLLtFGxvQIlkr1XgOUALtTiFVKTMqgAAAAASUVORK5CYII=);
    height: 30px;
    width: 15px;
    right: 10px;
    top: 0px;
    position: absolute;
    transition: 0.4s;
    -webkit-transition: 0.4s;
    -moz-transition: 0.4s;
    left: inherit;
  }

  #animationRope {
    display: block;
  }

  .droite {
    text-align: right;
  }

  #diveIn {
    right: calc(50vw - 30px);
    font-size: 23px;
  }

  #diveIn:after {
    right: 12px;
  }

  #allInfo {
    top: 132px;
    left: 0px;
  }

  /* .info {
    width: 100px;
  } */

  .imgAll {
    width: 90vw;
    margin-bottom: 15px;
    margin-left: 5px;
  }

  .gauche h3 {
    text-align: right;
    padding-right: 8px;
  }

  .gauche p {
    width: 300px;
    width: 250px;
    text-align: left;
  }

  .droite p {
    width: 300px;
  }

  section.current h1 {
    display: none;
  }

  h1 {
    display: none;
  }

  #galerie figure {
    width: 60px;
    height: 60px;
  }

  #galerie .image {
    float: right;
  }

  #galerie figure img {
    height: 60px;
  }

  #header div {
    display: grid;
  }

  #logoWelcome img {
    position: absolute;
    right: calc(50vw - 150px);
    top: 168px;
    display: block;
    width: 300px;
    padding-top: 50px;
  }

  .section_home div {
    /* width: 90vw;
    padding-right: 10px !important;
    padding-left: 1px;
    min-width: 90vw; */
    width: 61vw;
    padding-right: 23px !important;
    padding-left: 7px;
    min-width: 88vw;
  }

  .middleLeft {
    margin-left: 38px;
  }

  #navigation {
    width: 100vw;
    margin: 0 auto;
    display: block;
    font-size: 15px;
  }

  .star span {
    width: 280px;
  }

  #menu {
    margin: 0 auto;
    display: block;
    text-align: center;
  }

  #wrapper {
    width: 100%;
  }

  #mesure {
    width: 20px;
    height: 6500px;
    margin-left: 90%;
  }

  #allInfo {
    top: 146px;
    padding-left: 0%;
    height: 30px;
  }

  .info {
    margin-left: 15px;
    font-size: 12px;
    width: 120px;
    padding: 0px;
  }

  section.current h1 {
    display: block;
  }

  h1 {
    display: block;
  }

  .gauche h2:before {
    content: url(../../static/img/arrowRight2.png);
    height: 30px;
    width: 15px;
    left: -26px;
    top: -1px;
    position: absolute;
    transition: 0.4s;
    -webkit-transition: 0.4s;
    -moz-transition: 0.4s;
  }

  .gauche.active h2:before {
    transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
  }
}
</style>



